import React from 'react';
import { motion } from 'framer-motion';
import { Gift, CheckCircle2 } from 'lucide-react';
export function BonusSection() {
  const bonuses = [{
    num: '01',
    title: 'Mapa Anti-Hinchazón +55™',
    items: ['Identificás exactamente qué hábito o alimento te está inflamando en 7 días', 'Sistema de detección simple, día a día'],
    value: '$12.000'
  }, {
    num: '02',
    title: 'Guía del Magnesio para Argentina™',
    items: ['Elegís el suplemento correcto para tu cuerpo sin gastar de más', 'Sin equivocarte entre marcas y formatos'],
    value: '$10.000'
  }, {
    num: '03',
    title: 'Recetario Liviano Express',
    items: ['Comés rico y sin pesadez', 'Ideal cuando tenés 15 minutos y poca energía'],
    value: '$9.000'
  }, {
    num: '04',
    title: 'Planner 21 Días Abdomen Liviano™',
    items: ['Seguís tu progreso día a día', 'Ves resultados reales sin abrumarte'],
    value: '$11.000'
  }, {
    num: '05',
    title: 'Lista Inteligente de Compras Anti-Pesadez™',
    items: ['Llevás al súper exactamente lo que necesitás', 'Sin productos raros ni caros'],
    value: '$10.000'
  }];
  return <section className="py-24 bg-brand-black relative overflow-hidden" data-id="element-29" data-mp="2ofo4t69inki1">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-4xl h-[600px] bg-brand-gold/5 blur-[150px] rounded-full pointer-events-none" data-id="element-30" data-mp="1qtqpfhqfnvab" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-31" data-mp="20remiebihevn">
        <div className="max-w-5xl mx-auto" data-id="element-32" data-mp="20ptuavco680y">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-16" data-id="element-33" data-mp="25q82qei6njzi">
            <h2 className="text-3xl md:text-5xl font-bold text-brand-gold mb-4 flex flex-col md:flex-row items-center justify-center gap-4 font-[Poppins,_sans-serif]" data-id="element-34" data-mp="1h2vr4rdbnj0l">
              <Gift className="w-10 h-10" data-id="element-35" data-mp="1c6op39o1qrnx" />5 BONOS ESTRATÉGICOS
            </h2>
            <p className="text-xl text-white font-medium tracking-widest uppercase" data-id="element-36" data-mp="1q3aerxdrda79">
              Siempre Incluidos
            </p>
          </motion.div>

          <div className="grid gap-6 mb-16" data-id="element-37" data-mp="yc4f1i1y9eii">
            {bonuses.map((bonus, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-brand-dark border border-brand-gold/20 p-6 md:p-8 rounded-2xl flex flex-col md:flex-row gap-6 items-start relative overflow-hidden group hover:border-brand-gold/50 transition-colors" data-id="element-38" data-mp="tem11d92s93n" data-mpi={index}>
                <div className="bg-brand-gold/10 text-brand-gold font-bold text-xl px-4 py-2 rounded-lg shrink-0" data-id="element-39" data-mp="5c7n6p1l186i">
                  BONO {bonus.num}
                </div>

                <div className="flex-grow z-10" data-id="element-40" data-mp="3rqh5qhitzlzd">
                  <h3 className="text-xl font-bold text-white mb-3" data-id="element-41" data-mp="ja5mcn7c0y1f">
                    {bonus.title}
                  </h3>
                  <ul className="space-y-2" data-id="element-42" data-mp="o98u4fep5id3">
                    {bonus.items.map((item, i) => <li key={i} className="flex items-start gap-2 text-gray-300" data-id="element-43" data-mp="9chty3x782mf" data-mpi={i}>
                        <CheckCircle2 className="w-5 h-5 text-brand-gold shrink-0 mt-0.5" data-id="element-44" data-mp="ecmb7w5xl1dp" />
                        <span data-id="element-45" data-mp="2u41nvemhsmba">{item}</span>
                      </li>)}
                  </ul>
                </div>

                <div className="shrink-0 flex flex-row items-center gap-3 z-10" data-id="element-46" data-mp="3f8omeu5pzi4n">
                  <span className="text-gray-500 line-through text-sm" data-id="element-47" data-mp="3ahgc7vwkfsqf">
                    {bonus.value}
                  </span>
                  <span className="bg-brand-light text-brand-dark font-bold px-4 py-1 rounded-full" data-id="element-48" data-mp="35hk3jjcxbd4j">
                    GRATIS
                  </span>
                </div>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="bg-brand-gold/10 border border-brand-gold/30 py-8 px-6 rounded-2xl flex flex-col items-center justify-center gap-2" data-id="element-49" data-mp="20v9uxyfvxwa">
            <p className="text-sm md:text-base font-semibold tracking-widest uppercase text-[#D4A843]" data-id="element-50" data-mp="2crblrsmauuqh">
              VALOR TOTAL BONOS
            </p>
            <p className="text-3xl md:text-4xl font-bold text-gray-400 line-through" data-id="element-51" data-mp="ndlpxbej9ety">
              $52.000
            </p>
            <p className="text-xl md:text-2xl text-brand-gold font-bold text-center" data-id="element-52" data-mp="sbx0xpgkdvdr">
              → GRATIS con tu Sistema Rescate Intestinal +55™
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}